module.exports = __webpack_public_path__ + "img/tips6.c6c066d8.png";